module.exports = __webpack_public_path__ + "media/images/lb/240-e152d561bbc06dff10ce108adf284628.svg";